<template>
    <el-calendar ref="calendar" v-loading="loading" v-model="date">
        <template #header="{date: _date}">
            {{ _date }}
            <el-date-picker v-model="date"></el-date-picker>
        </template>
        <template #date-cell="{data}">
            <div>{{ data.day.split('-').slice(1).join('-') }}</div>
            <div v-if="date_map[data.day]" @click="remove(data.day)">
                <el-image style="width: 70px" lazy
                          :src="`${$root.cdn_url}/${date_map[data.day].thumbnail}`"></el-image>
            </div>
            <div v-else style="height: 70px" @click="openDialog(data.day)"></div>
        </template>
    </el-calendar>
    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
        <el-form ref="form" label-width="0" :model="form">
            <el-form-item prop="image_id" :rules="[{required: true, message: '请选择图片'}]">
                <el-radio-group v-model="form.image_id">
                    <el-radio :label="d.id" v-for="d in dataFilter">
                        <div style="width: 100px;">
                            <el-image lazy :src="`${$root.cdn_url}/${d.thumbnail}`"
                                      style="width: 90px;display: block"></el-image>
                            <b style="white-space: normal">{{ d.remark }}</b>
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" text :loading="loading" @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from 'ts-axios-new';
import {ElMessageBox} from 'element-plus'

export default {
    name: "Daily",
    data() {
        return {
            loading: false, data: [], date_map: {}, dialog_opened: false, image_list: [], date: new Date(),
            form: {
                date: '',
                image_id: '',
            }
        }
    },
    methods: {
        init() {
            this.loading = true;
            axios.all([
                axios.get(`/cms/v1/daily`).then(res => {
                    res.data.data.imageList.forEach(d => {
                        this.date_map[d.date] = d;
                    });
                }),
                axios.get(`/cms/v1/image`, {params: {module: 3, limit: 1000, status: 3}}).then(res => {
                    this.image_list = res.data.data.imageList;
                }),
            ]).then(_ => {
                this.loading = false;
            })
        },
        remove(date) {
            ElMessageBox.confirm('确定要删除这一天的图片吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/daily/${this.date_map[date].id}`).then(res => {
                    this.loading = false;
                    delete this.date_map[date];
                });
            }).catch(_ => {
            })
        },
        openDialog(date) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                this.form.date = date;
            });
        },
        reset() {
            this.$refs.form.resetFields();
            this.loading = this.dialog_opened = false;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    axios.post(`/cms/v1/daily`, this.form).then(res => {
                        this.date_map[res.data.data.date] = res.data.data;
                        this.reset();
                    })
                }
            })
        },
    },
    mounted() {
        this.init();
    },
    computed: {
        dataFilter() {
            return this.image_list.filter(image => {
                let valid = true;
                Object.keys(this.date_map).forEach(date => {
                    if (this.date_map[date].image_id === image.id) {
                        valid = false;
                    }
                })
                return valid;
            })
        }
    },
}
</script>

<style scoped>
.el-calendar ::v-deep(.el-calendar-day) {
    height: fit-content;
    width: 160px;
    min-height: var(--el-calendar-cell-width);
}

.el-radio {
    height: fit-content;
    margin: 5px;
}
</style>